<template>
  <el-pagination v-if="total > 0" class="block" background="" :total="total"
    @current-change="pageChanged" @prev-click="pageChanged" @next-click="pageChanged"
    :page-size="pagination.limit" :page-count="pagination.totalPage"
    :current-page="pagination.currentPage" />
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    pagination: {
      required: true
    },
    changed: {
      type: Function
    }
  },
  methods: {
    pageChanged(currentPage) {
      if (this.changed) {
        this.changed({ pagination: { currentPage, limit: this.pagination.limit } })
      }
    }
  }
}
</script>
